import React, { ReactNode } from 'react';
import { Modal } from '@ver-uds/react';

export type HelpModalProps = {
  open: boolean;
  close(): void;
  modalContent: {
    header: string;
    body: ReactNode;
  };
};

const HelpModal = ({ open, close, modalContent }: HelpModalProps): JSX.Element => {
  const modalId = 'edit-company-information-help-modal';
  const modalHeader = modalContent.header === '' ? '' : modalContent.header.toString();

  return (
    <Modal id={modalId} header={modalHeader} open={open} close={close} fixedToTop>
      <Modal.Content>{modalContent.body}</Modal.Content>
    </Modal>
  );
};

// istanbul ignore if: Not used for test environment; Modal.setAppElement should be called in the tests directly.
if (process.env.NODE_ENV !== 'test') {
  Modal.setAppElement('#root');
}

export default HelpModal;
